// Draft storage for the Proforma Invoice form.
const KEY = "uee_proforma_draft_v1";
export const DRAFT_EVENT = "uee-pdraft-change";
export const DRAFT_RESUME_EVENT = "uee-pdraft-resume";

export function loadDraft() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const d = JSON.parse(raw);
    return d && d.form ? d : null;
  } catch (e) {
    return null;
  }
}

export function saveDraft(draft) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...draft, updatedAt: Date.now() }));
    window.dispatchEvent(new Event(DRAFT_EVENT));
  } catch (e) {
    /* storage full / blocked — draft just won't persist */
  }
}

export function clearDraft() {
  try {
    localStorage.removeItem(KEY);
    window.dispatchEvent(new Event(DRAFT_EVENT));
  } catch (e) {
    /* ignore */
  }
}
